var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #dc1e37;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .st1 {\n        fill: #dc1e37;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "15.13 5.9 15.13 2.15 4.87 2.15 4.87 10.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4.87 11.69 1.08 8.31 8.65 8.31 4.87 11.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "4.87 14.1 4.87 17.85 15.13 17.85 15.13 9.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15.13 8.31 18.92 11.69 11.35 11.69 15.13 8.31"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1\\u306E\\u30B3\\u30D4\\u30FC",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1\\u306E\\u30B3\\u30D4\\u30FC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.13,1.15H4.87c-.55,0-1,.45-1,1v6.16H1.08l3.78,3.39,3.78-3.39h-2.78V3.15h8.27v2.74h2v-3.74c0-.55-.45-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.92,11.69l-3.78-3.39-3.78,3.39h2.78v5.16H5.87v-2.75h-2v3.75c0,.55.45,1,1,1h10.27c.55,0,1-.45,1-1v-6.16h2.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.311ea6d0706b7ad69f2988593889dfb3.svg";
export { ForwardRef as ReactComponent };